<template src='./DeviceAddUpdate.html'></template>
<script>
import { CONTACT_NUMBER_LENGTH, MESSAGES } from "@/utils/constants";
import { notify, notifyApiError, notifyError, notifyWarn } from "@/utils/notification-helper";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("device");
import FileUpload from "./FileUpload.vue";
import FormGenerator from "@/components/Fields/FormGenerator";
export default {
  components: {
    FileUpload,
    FormGenerator,
  },
  data: function () {
    return {
      add: this.$route.params.add,
      deviceData: {},
      code: null,
      imei: null,
      simNumber: null,
      vendorName: null,
      expand: true,
      sensorObjects: [], // adding multiselect sensors
      selectedSensors: [],
      validations: {
        isSensorRequired: false,
      },
      deviceTypes:[],
      deviceTypeId:null,
      tenantType: null,
      tenantTypeId: null,
      deviceType:null,
      id:null,
      dataRetentionDays:null,
      trackingInterval:null,
      broadcastingInterval:null,
      syncInterval:null,
      disableStorage:false,
      disableTracking:false,
      calculateOdoReading:false
    };
  },
  methods: {
    goToListPage: function () {
      this.$store.commit("device/cancel");
      this.$router.push({ name: "deviceLanding" });
    },
    clearEntries: function () {
      // this.name = null;
      // this.vendorName = null;
      this.code = null;
      this.imei = null;
      this.sensors = null;
      this.simNumber = null;
      for (const key in this.validations) this.validations[key] = false;
    },
    handleChangeVendor(event) {
      this.vendorName = event.value.id;
    },
    validateFields() {
      if (this.selectedSensors.length === 0) {
        this.validations.isSensorRequired = true;
      }
    },
  addDevice: function () {
      this.validateFields();
      if (this.imei && this.simNumber && this.selectedSensors.length > 0 ) {
        this.deviceData = {
          imei: this.imei,
          simCard_No: this.simNumber,
          sensors: this.selectedSensors.join(','),
          deviceTypeId:this.deviceTypeId?this.deviceTypeId.id:null,
          tenantId: this.tenantTypeId.id?this.tenantTypeId.id:null,
          id:this.id,
          DataRetentionDays:this.dataRetentionDays ? this.dataRetentionDays : 0,
          TrackingInterval:this.trackingInterval ? this.trackingInterval:0,
          BroadcastingInterval:this.broadcastingInterval ? this.broadcastingInterval : 0,
          SyncInterval:this.syncInterval ? this.syncInterval :0,
          DisableStorage:this.disableStorage,
          DisableTracking:this.disableTracking,
          CalculateOdoReading:this.calculateOdoReading
        };
        if (this.add) {
          this.$store
            .dispatch("device/addDevice", this.deviceData)
            .then((data) => {
              if (data.status) {
                notify(MESSAGES.RECORD_CREATE_SUCCESS);
                this.goToListPage();
                this.clearEntries();
              } else {
                notifyWarn(data.message);
              }
            })
            .catch((err) => {
              try {
                notifyError(err.response.data.message);
              } catch (error) {
                notifyApiError({message:"Something went wrong"});
              }
            });
        } else {
          this.$store
            .dispatch("device/updateDevice", this.deviceData)
            .then(() => {
              notify(MESSAGES.CHANGES_SAVE_SUCCESS);
              this.goToListPage();
              this.clearEntries();
            })
            .catch(notifyApiError);
        }
      }
    },
    validateDigits(e) {
      if ((e.target.value).length <= CONTACT_NUMBER_LENGTH) {
        this.simNumber = e.target.value
      } 
    },
    async getDataOnload() {
      // await this.$store.dispatch("loadVendors", null, { root: true });
      this.sensorObjects = this.initialData.sensors;
     
      if (!this.$route.params.add) {
        this.title = "Update Device";
        this.deviceEditData = this.$store.getters["device/getEditDevice"];
         console.log("deviceEditData",this.deviceEditData)
        this.code = this.deviceEditData.id;
        this.imei = this.deviceEditData.imei;
        this.simNumber = this.deviceEditData.simCardNumber;
        this.selectedSensors = this.deviceEditData.sensors
          ? this.deviceEditData.sensors.split(",")
          : [];
        this.deviceTypeId= this.getCommonDeviceTypes.find(i=>i.id===this.deviceEditData.deviceTypeId)
        this.tenantTypeId= this.getCommonTenantTypes.find(i=> i.id===this.deviceEditData.tenantId)
        // this.tenantType = 

        this.id=this.deviceEditData.id;
        this.dataRetentionDays =this.deviceEditData.dataRetentionDays,
      this.trackingInterval=this.deviceEditData.trackingInterval,
      this.broadcastingInterval=this.deviceEditData.broadcastingInterval,
      this.syncInterval=this.deviceEditData.syncInterval,       
      this.disableStorage = this.deviceEditData.disableStorage,
        this.disableTracking = this.deviceEditData.disableTracking,
        this.calculateOdoReading = this.deviceEditData.calculateOdoReading
      } else {
        this.title = "Add Device";
      }
    },
    expandPanel() {
      let header = document.querySelectorAll('#panelbar .k-header');
      let element = document.querySelectorAll('#panelbar .k-content')[0];
      element.setAttribute('style','display:block !important');
      header[0].addEventListener('click', () => {
      if(element.getAttribute('style') == "display: block;") {
      element.setAttribute('style','display:none !important');
      }
      });
      },
    },
  mounted() {
    this.expandPanel();
  },
  computed: {
    vendorList() {
      return this.$store.state.vendors;
    },
    ...mapState(["initialData"]),
    getCommonDeviceTypes(){
      return this.initialData.deviceTypes
    },
    getCommonTenantTypes() {
      return this.initialData.tenants
    }
  },
  async beforeMount() {
    this.getDataOnload();
  },
};
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
.k-form, .k-form-inline {
    font-size: 1rem;
    line-height: 1.5;
    padding: 1rem !important;
}
.page-header .title-text {
    font-size: 12px;
    margin-left: 10px;
}
.mobile_side_lbl{width: 70% !important;}
.mobile_side_btn{display: flex;}
.driver_header_mobile{flex-direction: row !important; overflow-x: auto;padding: 10px 10px 10px 10px;}
}
</style>